import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateBlockValue } from 'i18n';
import {
    deserializeTreeValue,
    deserializeListValue,
} from 'components/inputs/TreeTablePicker/helpers';
import { useGetFilterValues } from 'components/SentenceFilter/FilterManagees/hooks';
import FilterValueWrapper, { FilterValuesProps } from './FilterValueWrapper';

const MAX_FILTERS = 4;

const RegularFilterValues = ({
    singleFilter,
}: FilterValuesProps): React.ReactElement<FilterValuesProps> => {
    const { t } = useTranslation();

    const {
        data: filterWithValues,
        isLoading,
        isError,
    } = useGetFilterValues(singleFilter, false);

    let filterValues = singleFilter.values;
    let filterTreeValues = singleFilter.treeValues;
    if (!isLoading && !isError) {
        filterValues = filterWithValues?.values;
        filterTreeValues = filterWithValues?.treeValues;
    }

    if (singleFilter.value === null) {
        throw new Error('PrintRegularFilterError, unexpected null value');
    }
    if (filterTreeValues !== undefined && filterTreeValues !== null) {
        filterValues = deserializeTreeValue(
            singleFilter.value,
            filterTreeValues,
            (node) => node.value,
        );
    } else {
        filterValues = deserializeListValue(singleFilter.value, filterValues);
    }

    const reduceFilters = filterValues.length > MAX_FILTERS;
    const reducedFilterValues = reduceFilters
        ? filterValues.slice(0, MAX_FILTERS)
        : filterValues;

    // Example: for value scope:default_rh, set label "Périmètre des RH"
    reducedFilterValues.forEach((filterValue) => {
        if (!filterValue.label && filterValue.value.includes('scope:')) {
            const scope = filterValue.value.split('scope:')[1];
            filterValue.label = t(`printPage.${scope}`);
        }
    });

    return (
        <>
            {reducedFilterValues.map((singleValue) => (
                <FilterValueWrapper
                    key={singleValue.value}
                    data-testid="filter-value"
                >{`${translateBlockValue(
                    singleValue.label,
                )}`}</FilterValueWrapper>
            ))}
            {reduceFilters ? (
                <FilterValueWrapper>
                    +{filterValues.length - MAX_FILTERS}
                </FilterValueWrapper>
            ) : null}
        </>
    );
};

export default RegularFilterValues;
